import { render } from "./input-item.vue?vue&type=template&id=8e6038ca"
import script from "./input-item.vue?vue&type=script&lang=js"
export * from "./input-item.vue?vue&type=script&lang=js"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__